let accessToken = '';
var last_solicitud = 0;

export const setUserData = (user, clave) => {
  let ocultito = JSON.stringify({ user: user, clave: clave });
  let encrypted = window.CryptoJS.AES.encrypt(ocultito, 'estanoesunaclavesecreta');
  // window.console.log( 'CRYPTO:::',encrypted );
  window.localStorage.setItem('USERDATALOGIN', encrypted);
};

export const getUserData = () => {
  const ocultito = window.localStorage.getItem('USERDATALOGIN');
  let decryptedBytes = window.CryptoJS.AES.decrypt(ocultito, 'estanoesunaclavesecreta');
  let plaintext = decryptedBytes.toString(window.CryptoJS.enc.Utf8);
  //window.console.log( 'DECRYPTO:',plaintext );
  return plaintext;
}

export const relogin = (/*auth*/) => {
  var sol = new Date().getTime();
  if (sol < last_solicitud) return;
  const ocultito = window.localStorage.getItem('USERDATALOGIN');
  let decryptedBytes = window.CryptoJS.AES.decrypt(ocultito, 'estanoesunaclavesecreta');
  let plaintext = decryptedBytes.toString(window.CryptoJS.enc.Utf8);
  //window.console.log( 'DECRYPTO:',plaintext );
  const datauser = plaintext;
  var u = JSON.parse(datauser);
  if (!u) return;
  last_solicitud = sol + 1000 * 4; // + 4 secods

  var myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  var raw = JSON.stringify({ username: u.user, password: u.clave });
  var requestOptions = { method: 'POST', headers: myHeaders, body: raw };

  fetch(process.env.VUE_APP_AUTH_POST, requestOptions)
    .then((response) => response.json())
    .then(
      /*result*/ () => {
        /*window.console.log(result.accessToken);*/ setAccessToken(accessToken);
      },
    )
    .catch((error) => window.console.log('error', error));
};

export const setAccessToken = (s) => {
  //accessToken = s;
  accessToken = window.CryptoJS.AES.encrypt(s, 'estanoesunaclavesecreta');
  // window.console.log( '>>>>>:::: ',accessToken,s );
  window.localStorage.setItem('TOKEN', accessToken);
};

export const getAccessToken = () => {
  let s = window.localStorage.getItem('TOKEN');
  //relogin( auth );
  let decryptedBytes = window.CryptoJS.AES.decrypt(s, 'estanoesunaclavesecreta');
  let plaintext = decryptedBytes.toString(window.CryptoJS.enc.Utf8);
  accessToken = plaintext;
  // window.console.log( '>>>>>: ',accessToken,s );
  return accessToken;
};

export const reloginManual = async () => {
  var sol = new Date().getTime();
  if (sol < last_solicitud) return;
  const ocultito = window.localStorage.getItem('USERDATALOGIN');
  let decryptedBytes = window.CryptoJS.AES.decrypt(ocultito, 'estanoesunaclavesecreta');
  let plaintext = decryptedBytes.toString(window.CryptoJS.enc.Utf8);
  //window.console.log( 'DECRYPTO:',plaintext );
  const datauser = plaintext;
  var u = JSON.parse(datauser);
  if (!u) return;
  last_solicitud = sol + 1000 * 4; // + 4 secods

  var myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  var raw = JSON.stringify({ username: u.user, password: u.clave });
  var requestOptions = { method: 'POST', headers: myHeaders, body: raw };

  let res = await fetch(process.env.VUE_APP_AUTH_POST, requestOptions)
    .then((response) => response.json())
    .then( (d) => d) 
    .catch((error) => error);
    // window.console.log('reloginnnn',res);
    if(res && res.ok) {
      setAccessToken(res.accessToken);
      return true
    }
  return false;
};

/* toma el username|password y los manda a la url de los webinars para auth con el sys de los webinars */
export const encryptToSendWebinars = (vue) => {
  const claveShift = 3;
  const datastr = getUserData();
  if(!datastr) return; 
  const datauser = JSON.parse(datastr);
  const idcargo = vue.$store.state.CARGO.id;
  const iduser = vue.$store.state.DATA_USER.id;
  const text = datauser.user+'|'+datauser.clave+'|'+idcargo+"|"+iduser;
  // window.console.log("datauser",datauser);
  
  let encryptedText = '';
  
  for (let i = 0; i < text.length; i++) {
    let char = text[i];
    
    if (char.match(/[a-z]/i)) {
      let code = text.charCodeAt(i);
      
      if (code >= 65 && code <= 90) {
        char = String.fromCharCode(((code - 65 + claveShift) % 26) + 65);
      } else if (code >= 97 && code <= 122) {
        char = String.fromCharCode(((code - 97 + claveShift) % 26) + 97);
      }
    }
    
    encryptedText += char;
  }

  const unidad = vue.$store.state.CARGO.sede.unidad_negocio;
  let host = process.env.VUE_APP_WEBINARS;
  if(unidad==10) host = process.env.VUE_APP_WEBINARSDBS;
  
  const url = host+'#/auth/'+encryptedText; 
  window.open(url);
  return encryptedText;
}

/* toma el username|password y los manda a la url de los webinars para auth con el sys de los webinars */
export const encryptToSendWapito = () => {
  const claveShift = 3;
  const datastr = getUserData();
  if(!datastr) return; 
  const datauser = JSON.parse(datastr);
  const text = datauser.user+'|'+datauser.clave;
  // window.console.log("datauser",datauser);
  
  let encryptedText = '';
  
  for (let i = 0; i < text.length; i++) {
    let char = text[i];
    
    if (char.match(/[a-z]/i)) {
      let code = text.charCodeAt(i);
      
      if (code >= 65 && code <= 90) {
        char = String.fromCharCode(((code - 65 + claveShift) % 26) + 65);
      } else if (code >= 97 && code <= 122) {
        char = String.fromCharCode(((code - 97 + claveShift) % 26) + 97);
      }
    }
    
    encryptedText += char;
  }
  
  // const url = process.env.VUE_APP_WAPITO+'#/auth?t='+encryptedText; 
  const url = 'https://esam.edu.bo/sistemita/wapito/'; 
  window.open(url);
  return encryptedText;
}

export const encryptToUpi = () => { 
  const datastr = getUserData();
  if(!datastr) return; 
  const datauser = JSON.parse(datastr);
  const text = datauser.user+'|'+datauser.clave;
  
  let encryptedText = btoa(text);
  return encryptedText;
}